import React, { useEffect, useState } from "react";
import { string, object } from "prop-types";
import get from "lodash/get";
import { useDispatch, useSelector } from "react-redux";
import { throttle } from "lodash";

import { AdContainer } from "../../ads";
import "./sticky-banner.m.css";
import { setIsStickyBannerVisible } from "../../store/actions";
import useAdType from "../../helper/useAdType";

const StickyBanner = ({ isVisible, showStickyNavbar = true }) => {
  const pageType = useSelector((state) => get(state, ["qt", "pageType"]));
  const story = useSelector((state) => get(state, ["qt", "data", "story"], {}));
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const subscriptionConfig = get(qtState, ["data", "subscriptionConfig", "ad-lite-cta"], {});
  const tempHideAd =
    story["story-template"] === "brandspot-with-no-ad" ||
    story["story-template"] === "exclusive-story-without-ad" ||
    story?.slug?.includes("dhbrandspot-pr/best-crypto-casinos-2025-my-go-to-sites-for-bitcoin-gambling-3470705");

  const [showAd, setShowAd] = useState(true);
  const [isClosed, setClosed] = useState(false);
  // Scroll behaviour change commented - not required for now
  // const [hideOnScroll, setHideOnScroll] = useState(true); // Hidden at top
  // const [bottomNavVisible, setBottomNavVisible] = useState(false); // Track bottom nav visibility
  const dispatch = useDispatch();
  const adType = useAdType();

  if (tempHideAd) return null;

  useEffect(() => {
    if (showAd && !isClosed) {
      dispatch(setIsStickyBannerVisible(true));
    } else {
      dispatch(setIsStickyBannerVisible(false));
    }
  }, [showAd, isClosed]);

  /* Scroll behaviour change commented - not required for now
  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleScrollStateChange = (event) => {
        const { isAtTop, scrollDirection, scrolledToBottom } = event.detail;
        setHideOnScroll(isAtTop);

        if (isAtTop) {
          setBottomNavVisible(false);
        } else if (scrolledToBottom) {
          setBottomNavVisible(true);
        } else if (scrollDirection === "down") {
          setBottomNavVisible(false);
        } else if (scrollDirection === "up") {
          setBottomNavVisible(true);
        }
      };

      window.addEventListener("mobileScrollStateChange", handleScrollStateChange);

      return () => {
        window.removeEventListener("mobileScrollStateChange", handleScrollStateChange);
      };
    }
  }, []);
  */

  const adsId = {
    "story-page": "div-gpt-ad-1680157923413-0",
    "home-page": "div-gpt-ad-1680157033747-0",
    "izooto-sticky": "div-gpt-ad-1711972192178-0"
  };

  const ads = {
    "story-page": "DH_Mweb_AT_Sticky",
    "home-page": "DH_Mweb_HP_Sticky",
    "izooto-sticky": "DH_Mweb_AT_Sticky_ym"
  };

  return (
    <div styleName="wrapper">
      <div id="sticky-ad-banner" styleName={`banner ${isVisible && showAd && !isClosed ? (showStickyNavbar ? "nav-visible" : "") : "hide"}`}>
        <div styleName="top-bar">
          <a
            href="/subscribe"
            styleName="go-ad-lite"
            onClick={(e) => {
              e.preventDefault();
              let slotName = adType === "izooto" ? ads["izooto-sticky"] : ads[pageType] || "PV_Mweb_HP_Sticky";
              if (window) {
                const { getAuthStatus, cleanDataLayerPayload } = require("../../helper/datalayer-utils");
                const { status, uuid } = getAuthStatus();
                const formattedStatus = status === "not_logged_in" ? "non_logged_in" : status;

                const eventPayload = {
                  event: "ad_lite_button_click",
                  ad_slot_name: slotName,
                  auth_status: formattedStatus
                };

                if (status === "logged_in" && uuid && uuid !== "NA") {
                  eventPayload.uuid = uuid;
                }

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push(cleanDataLayerPayload ? cleanDataLayerPayload(eventPayload) : eventPayload);
                sessionStorage.setItem("subscribe_source", slotName);
                sessionStorage.setItem("pending_subscribe_source", slotName);
              }
              setTimeout(() => {
                window.location.assign("/subscribe");
              }, 300);
            }}
          >
            {subscriptionConfig?.["cta-text"] || "Go Ad Lite"}
          </a>
          <div
            styleName="cross-btn"
            onClick={() => {
              setShowAd(false);
              setClosed(true);
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
              <path d="M0.842105 6L0 5.15789L2.16541 2.99248L0 0.842105L0.842105 0L3.00752 2.16541L5.15789 0L6 0.842105L3.83459 2.99248L6 5.15789L5.15789 6L3.00752 3.83459L0.842105 6Z" fill="black"/>
            </svg>
          </div>
        </div>
        <div styleName="ad-wrapper">
          <span styleName="ad-text">{subscriptionConfig?.["advertisment-text"] || "ADVERTISEMENT"}</span>
          {/* <span styleName="container-text">ADVERTISEMENT</span> */}
          <div styleName="sticky-ad">
            <AdContainer
              showText={false}
              id={adType === "izooto" ? adsId["izooto-sticky"] : adsId[pageType] || "div-gpt-ad-1680157033747-0"}
              mobile={adType === "izooto" ? ads["izooto-sticky"] : ads[pageType] || "DH_Mweb_HP_Sticky"}
              isExternalAdPath={adType === "izooto" ? true : false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

StickyBanner.propTypes = {
  pageType: string,
  story: object
};

export default StickyBanner;
